export const GOOGLE_OAUTH_CLIENT_ID =
  "555870411110-6h9g25v8494l2arl7dmqtckhd5sj2f89.apps.googleusercontent.com";

// Fallback coordinates when hotel location cannot be determined
export const DEFAULT_HOTEL_LOCATION = { lat: 30.4191947, lng: -87.2117292 };

export const subscriptionList = [
  {
    tier: "ST",
    sellers: 10,
    price: 40,
    title: "Standard",
    desc: "Made for starters.",
    bg: "bg-info-light",
    text: "text-info-dark",
  },
  {
    tier: "PR",
    sellers: 20,
    price: 80,
    title: "Pro",
    desc: "Created for growing starters.",
    bg: "bg-purple-100",
    text: "text-purple-700",
  },
  {
    tier: "MX",
    sellers: 40,
    price: 135,
    title: "Max",
    desc: "The plan for everyone.",
    bg: "bg-warning-light",
    text: "text-warning-dark",
  },
  {
    tier: "UL",
    sellers: 100,
    price: 235,
    title: "Ultra",
    desc: "The plan you’ve always needed.",
    bg: "!bg-slate-900",
    text: "text-gradient",
  },
];
/**
 * Custom window event that asks the marketing topbar's Insights pill
 * (LiveActivityToggle) to open its panel. Fired when the first-booking
 * congrats popup is dismissed — customers often miss the Insights pill.
 */
export const OPEN_INSIGHTS_EVENT = "autumn:open-insights";
